import React, { cloneElement, isValidElement } from 'react';
import { useLocation } from 'react-router-dom';
import BottomNavigation from './Navigation';
import AppShell from './AppShell';
import './Layout.css';

interface LayoutProps {
  children: React.ReactNode;
  showBottomNav?: boolean;
}

const Layout: React.FC<LayoutProps> = ({ children, showBottomNav = true }) => {
  const location = useLocation();

  // 在播放器页面不显示底部导航
  const shouldShowBottomNav = showBottomNav && location.pathname !== '/player';

  // 如果children是AppShell组件，给它传递footer
  if (isValidElement(children) && children.type === AppShell) {
    return cloneElement(children as React.ReactElement<any>, {
      footer: shouldShowBottomNav ? <BottomNavigation /> : undefined
    });
  }

  // 否则保持原有的结构（用于其他页面）
  return (
    <div className="layout">
      {children}
      {shouldShowBottomNav && <BottomNavigation />}
    </div>
  );
};

export default Layout;
